import styled from 'styled-components';
import { Link } from 'react-router-dom';

import * as colors from '../../styles/colors';
import * as mixins from '../../styles/mixins';

export const StyledLink = styled(Link)`
  ${mixins.transition};
  font-weight: ${props => props.theme.button.fontWeight};
  color: ${props => props.theme.terinary.color};
  border-radius: ${props => props.theme.terinary.btnBorderRadius};
  text-decoration: none;
  padding: 0.5rem 2rem !important;
  white-space: nowrap;
  margin: 30px 0;
  background-color: ${colors.white};
  border: 2px solid ${props => props.theme.terinary.border};
  text-align: center;

  &:hover {
    text-decoration: none;
  }

  .close-icon {
    position: relative;
    left: 10px;
    top: -1px;
    border: 1px solid transparent;
    background-color: transparent;
    display: inline-block;
    outline: 0;
    cursor: pointer;
  }

  .chevron {
    position: relative;
    left: 10px;
    top: -2px;
    border: 1px solid transparent;
    background-color: transparent;
    display: inline-block;
    outline: 0;
    cursor: pointer;
  }

  // anchors dont have disabled so have to use props
  ${props =>
    props.disabled === true && {
      'opacity': 0.4,
      'cursor': 'default',
      'pointer-events': 'none',
    }};
`;
